export const toYesNo = (value: boolean, yes: string, no: string) => (value ? yes : no);
